var map = {
	"./frontend/AndroidGuide.vue": 27359,
	"./frontend/Banking.vue": 38194,
	"./frontend/BetslipHistory.vue": 87273,
	"./frontend/BodyFB.vue": 92373,
	"./frontend/Commission.vue": 56978,
	"./frontend/ContactUs.vue": 75446,
	"./frontend/DataTable.vue": 36107,
	"./frontend/Deposit.vue": 8033,
	"./frontend/History.vue": 6638,
	"./frontend/Home.vue": 10450,
	"./frontend/IOSGuide.vue": 26635,
	"./frontend/Iframe copy.vue": 34991,
	"./frontend/Iframe.vue": 40069,
	"./frontend/Index.vue": 61045,
	"./frontend/Live.vue": 4221,
	"./frontend/LiveScore.vue": 72184,
	"./frontend/MainMenu.vue": 24461,
	"./frontend/MatchResult.vue": 37680,
	"./frontend/MaungFB.vue": 66098,
	"./frontend/Promotion.vue": 68350,
	"./frontend/Setting.vue": 29757,
	"./frontend/VideoLink.vue": 34377,
	"./frontend/VipLevels.vue": 83553,
	"./frontend/Withdraw.vue": 83200,
	"./frontend/auth/Login.vue": 30373,
	"./frontend/auth/Register.vue": 33064,
	"./frontend/auth/Rule.vue": 24557,
	"./frontend/auth/Verify.vue": 72659,
	"./frontend/auth/VerifyNotAuth.vue": 2395,
	"./frontend/components/AccountSelect.vue": 5056,
	"./frontend/components/AppHeader.vue": 209,
	"./frontend/components/DataTable.vue": 26014,
	"./frontend/components/FBPreviewVoucher.vue": 95851,
	"./frontend/components/FBVoucher.vue": 2575,
	"./frontend/components/FootballTeamCard.vue": 28722,
	"./frontend/components/GroupBox.vue": 86983,
	"./frontend/components/HomeBanner.vue": 82330,
	"./frontend/components/InputSelectDrawModal.vue": 16923,
	"./frontend/components/LuckyWheel.vue": 22745,
	"./frontend/components/NormalBox.vue": 41801,
	"./frontend/components/PreviewVoucher.vue": 42609,
	"./frontend/components/SideNav.vue": 30850,
	"./frontend/components/Table.vue": 66459,
	"./frontend/components/ThreedGroupBox.vue": 95959,
	"./frontend/components/TwoDSelect.vue": 20979,
	"./frontend/components/Voucher.vue": 40619,
	"./frontend/normal-user/2d/2d.vue": 39599,
	"./frontend/normal-user/2d/ClosedDays.vue": 10562,
	"./frontend/normal-user/2d/Home.vue": 40973,
	"./frontend/normal-user/2d/Winner.vue": 61927,
	"./frontend/normal-user/3d/3d.vue": 16395,
	"./frontend/normal-user/3d/Home.vue": 18467,
	"./frontend/normal-user/DreamBooks.vue": 15,
	"./frontend/normal-user/Index.vue": 56012,
	"./frontend/normal-user/bugyee/Room.vue": 38345,
	"./frontend/normal-user/game/Arcade.vue": 37436,
	"./frontend/normal-user/game/Fishing.vue": 46102,
	"./frontend/normal-user/game/Game.vue": 93490,
	"./frontend/normal-user/game/Slot.vue": 28896,
	"./frontend/normal-user/shankomee/Room.vue": 61017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;